import React, { Fragment, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  Chip,
  makeStyles,
  colors
} from '@material-ui/core';

import NavItem from './NavItem';

import { BsFillPersonFill } from "react-icons/bs";
import { MdGroup } from "react-icons/md";
import { BsHddNetworkFill } from "react-icons/bs";
import { MdMessage } from "react-icons/md";
import { MdEngineering } from "react-icons/md";
import { AiFillSetting } from "react-icons/ai";
import { Activity } from 'react-feather';
import { AiFillTool } from "react-icons/ai";
import { AiOutlineAreaChart } from "react-icons/ai";
import {BsCurrencyExchange} from "react-icons/bs";

const items = [
  {
    href: '/adm/company',
    icon: AiOutlineAreaChart,
    title: 'Operação',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/users',
    icon: BsFillPersonFill,
    title: 'Usuário',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/groups',
    icon: MdGroup,
    title: 'Equipe',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/mailing',
    icon: MdMessage,
    title: 'Notificação',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/adm/equipments',
    icon: BsHddNetworkFill,
    title: 'Equipamento',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/adm/company',
    icon: AiOutlineAreaChart,
    title: 'Operação',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/users',
    icon: BsFillPersonFill,
    title: 'Usuário',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/groups',
    icon: MdGroup,
    title: 'Equipe',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/mailing',
    icon: MdMessage,
    title: 'Notificação',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/adm/equipments',
    icon: BsHddNetworkFill,
    title: 'Equipamento',
    color: colors.blue[400],
    profile: 'ENG'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/fin/main',
    icon: BsCurrencyExchange,
    title: 'Financeiro',
    color: colors.green[600],
    profile: 'ENG'
  },
  {
    href: '/sup/main',
    icon: AiFillTool,
    title: 'Assistência Técnica',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/cfg/main',
    icon: AiFillSetting,
    title: 'Configuração',
    color: colors.indigo[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {

  const classes = useStyles();

  const [user, setUser] = useState({
    avatar: localStorage.getItem('avatar'),
    firstname: localStorage.getItem('firstname'),
    lastname: localStorage.getItem('lastname'),
    company: localStorage.getItem('company'),
    profile: localStorage.getItem('profile')
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
      setUser(localStorage.getItem('user'));
    }
  }, []);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={1}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          variant="circle"
          src={`/static/images/avatars/`}
          to="/adm/main"
        />
        <Typography
          className={classes.name}
          color="secondary"
          variant="body2"
        >
          {user.firstname} {user.lastname}
        </Typography>
        <Chip
          size="small"
          color="primary"
          label={`Perfil de acesso é ` + user.profile + `.`}
        />
      </Box>
      <Divider />
      <Box p={1}>
        <List>
          {items.map((item) => (
            (item.profile == localStorage.getItem('profile')) ? (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                color={item.color}
              />) : ('')
          ))}
        </List>
      </Box>
      <Box flexGrow={1} hidden />
      <Box hidden
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Sair da Área de Administração?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui Você Entra na Área de Monitoramento do Sistema
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            href="/mon/main"
            variant="contained">
            Monitoramento
          </Button>
        </Box>
        <br></br>
        <Typography
          align="center"
          variant="body2"
        >
          Aqui você entra na área de gerenciamento do sistema
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
        >
          <Button
            color="secondary"
            component="a"
            href="/mgt/main"
            variant="contained">
            Manutenção
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {(localStorage.getItem('profile') === 'MON') ? (
            <div></div>
          ) : (
            content
          )}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {(localStorage.getItem('profile') === 'MON') ? (
            <div></div>
          ) : (
            content
          )}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default NavBar;
